import store from "@/store/index";

export default {
  received(data) {
    switch (data.data.to_state) {
      case "requested_on_gateway":
        store.dispatch("payable/updatePaymentMessage", {
          title: "Aguarde,",
          message: "Estamos criando o pedido no meio de pagamento."
        });
        break;

      case "created_on_gateway":
        store.dispatch("payable/updatePaymentMessage", {
          title: "Oba,",
          message: "O pedido foi criado no meio de pagamento. ;)"
        });

        store.dispatch("payable/createPayment");
        break;

      case "fail_to_created_on_gateway":
      case "failed_to_request_payment":
        store.dispatch("payable/setErrorOnPayment");

        break;

      case "payment_requested":
        store.dispatch("payable/updatePaymentMessage", {
          title: "Quase lá!",
          message: "Estamos enviando o seu pagamento ao meio de pagamento!"
        });
        break;

      case "cancelled":
        store.dispatch("payable/setErrorOnPayment");

        break;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_Shared/channels/order.js